import { ChatRoomMemoStatus } from '@/types/schema.generated'

export const chatRoomMemoStatusString: Record<ChatRoomMemoStatus, string> = {
  [ChatRoomMemoStatus.HasMemo]: 'メモあり',
  [ChatRoomMemoStatus.NoMemo]: 'メモなし',
}

export const allChatRoomMemoStatuses: ChatRoomMemoStatus[] = [
  ChatRoomMemoStatus.HasMemo,
  ChatRoomMemoStatus.NoMemo,
]
